<template>
	<CommonFlame :title="'工事完了証明'">
		<v-row no-gutters justify="end">
			<v-btn
				color="secondary"
				class="mt-2 ml-2"
				@click="$router.push({ name: 'construction_completion_certificate_edit', params: { id } })"
			>
				<v-icon class="mr-1">mdi-pencil</v-icon>
				編集
			</v-btn>
			<v-btn color="secondary" class="mt-2 ml-2" @click="updateCompletionCertificate">
				<v-icon class="mr-1">mdi-printer-outline</v-icon>
				印刷
			</v-btn>
			<v-btn color="secondary" class="mt-2 ml-2" @click="approve">
				<v-icon class="mr-1">mdi-check</v-icon>
				{{ confirmTextByStatus() }}
			</v-btn>
		</v-row>
		<ConstructionCompletionCertificateSection
			:construction_data.sync="construction"
			:type="'show'"
		/>
	</CommonFlame>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ConstructionCompletionCertificateSection from "./components/ConstructionCompletionCertificateSection.vue"

export default {
	components: {
		CommonFlame,
		ConstructionCompletionCertificateSection,
	},
	data() {
		return {
			id: this.$route.params.id,
			authority_flag: false,
			approval_authority_flag: false,
			construction: {},
			common,
		}
	},
	mounted() {
		this.fetchConstruction()
	},
	methods: {
		fetchConstruction() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/completion_certificates/${this.id}/edit`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					this.construction = res.data.construction
					this.authority_flag = res.data.authority_flag
					this.approval_authority_flag = res.data.approval_authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		confirmCompletionCertificate() {
			// TODO:
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.post(url, params, { headers })
				.then((res) => {
					this.construction = res.data.construction
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		confirmTextByStatus() {
			// TODO
			return "承認" // 仮
		},
	},
}
</script>
